module.exports = __webpack_public_path__ + "img/72.e5660c24.jpg";